// src/components/ProfileSkeleton.tsx
// Premium animated skeleton loader for the profile details page.
import Panel from '@/pages/dashboard/components/Panel'

export default function ProfileSkeleton() {
  return (
    <div className="animate-pulse flex-1 px-[10px] pb-[28px] pt-0 flex flex-col gap-6">
      <Panel className="bg-[var(--bg-2)] border border-[var(--glass-brd)] relative overflow-hidden p-8 sm:p-8 flex flex-col gap-6">
        {/* Subtle background glow effect placeholder */}
        <div className="absolute top-0 right-0 w-48 h-48 bg-[radial-gradient(circle,rgba(81,203,152,0.08)_0%,transparent_70%)] pointer-events-none" />

        {/* Top section: Avatar + Names + Role Badge + Actions */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 pb-6">
          <div className="flex items-center gap-4 relative z-10 w-full md:w-auto">
            {/* Profile Avatar Placeholder */}
            <div className="w-20 h-20 rounded-full bg-[var(--skeleton)] border border-[var(--glass-brd)] shrink-0" />

            <div className="flex-1 min-w-0 space-y-2">
              {/* Name Placeholder */}
              <div className="h-6 bg-[var(--skeleton)] rounded-md w-36 sm:w-48" />
              {/* Email Placeholder */}
              <div className="h-4 bg-[var(--skeleton)] rounded-md w-48 sm:w-64" />
              
              {/* Badges Placeholder */}
              <div className="mt-3.5 flex flex-wrap items-center gap-2 pt-1">
                <div className="h-5 bg-[var(--skeleton)] rounded-full w-20" />
                <div className="h-5 bg-[var(--skeleton)] rounded-full w-16" />
              </div>
            </div>
          </div>

          {/* Inline Action Buttons Placeholder */}
          <div className="flex flex-wrap items-center gap-2.5 relative z-10 w-full md:w-auto mt-2 md:mt-0 pt-4 md:pt-0">
            <div className="h-9 bg-[var(--skeleton)] rounded-xl w-28" />
            <div className="h-9 bg-[var(--skeleton)] rounded-xl w-32" />
            <div className="h-9 bg-[var(--skeleton)] rounded-xl w-24" />
          </div>
        </div>

        {/* Inline Phone + Member Since Grid Placeholder */}
        <div className="grid gap-4 grid-cols-1 md:grid-cols-2 relative z-10">
          {/* Phone Number Field Placeholder */}
          <div className="p-4 rounded-2xl bg-[var(--field)] border border-[var(--field-brd)] flex gap-3.5 items-center">
            <div className="w-10 h-10 rounded-xl bg-[var(--skeleton)] shrink-0" />
            <div className="flex-1 space-y-1.5">
              <div className="h-3 bg-[var(--skeleton)] rounded w-20" />
              <div className="h-4 bg-[var(--skeleton)] rounded w-32" />
            </div>
          </div>

          {/* Member Since Field Placeholder */}
          <div className="p-4 rounded-2xl bg-[var(--field)] border border-[var(--field-brd)] flex gap-3.5 items-center">
            <div className="w-10 h-10 rounded-xl bg-[var(--skeleton)] shrink-0" />
            <div className="flex-1 space-y-1.5">
              <div className="h-3 bg-[var(--skeleton)] rounded w-20" />
              <div className="h-4 bg-[var(--skeleton)] rounded w-32" />
            </div>
          </div>
        </div>
      </Panel>
    </div>
  )
}
